/**
 * Donation types.
 */
export enum DonationType {
  Web = 'Web',
  Manual = 'Manual',
  Kiosk = 'Kiosk',
  QR = 'QR',
}
